import Repository from "../../repository";

export default {
    LoginUser: (payload) => Repository.post(`/api/AuthenticationGuest/LoginUser`, payload),
    ListServerName: (payload) => Repository.post(`/api/AuthenticationGuest/ListServerName`, payload),
    Register: (payload) => Repository.post(`/api/AuthenticationGuest/Register`, payload),
    SendCodeForgetPassword: (payload) => Repository.post(`/api/AuthenticationGuest/SendCodeForgetPassword`, payload),
    ChangePasswordBySecurityCode: (payload) => Repository.post(`/api/AuthenticationGuest/ChangePasswordBySecurityCode`, payload),
}